import { Component } from '@angular/core';

@Component({
  selector: 'zdb-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent { }
